export default __webpack_public_path__ + "static/media/other1-big.57a9349a.jpg";